<template>
    <Modal class="manage-gocardless-modal"
           data-component="ManageGoCardlessModal"
           :cancel="cancel"
           cancel-label="CLOSE"
           size="lg"
           icon="fa-user"
           title="GOCARDLESS.MANAGE_MODAL_TITLE">
        <div class="flex--desktop flex--gap flex--align-center mb-1">
            <div class="flex--grow pa-05">
                <h3 class="mt-0 mb-05">
                    {{ l('GOCARDLESS.MANAGE_TITLE') }}
                </h3>
                <p>
                    {{ l('GOCARDLESS.MANAGE_SUBTITLE') }}
                </p>
            </div>
            <div class="flex--no-grow flex--no-shrink">
                <SquareBtn size="lg"
                           block
                           :disabled="loading"
                           class="flex--no-grow flex--no-shrink px-1"
                           @click="addNewAccount">
                    <i class="fa-solid fa-plus-circle"></i> {{ l('GOCARDLESS.ADD_BANK_ACCOUNT') }}
                </SquareBtn>
            </div>
        </div>

        <CustomerGoCardlessPaymentTokens ref="payment-tokens"
                                         :customer-account-i-d="customerAccount.ID" />
    </Modal>
</template>

<script>
import CustomerGoCardlessPaymentTokens from '@/epos/vue/modals/ManageGoCardless/CustomerGoCardlessPaymentTokens';
import Modal from '@/vue/components/Modals/Modal';
import SquareBtn from '@/vue/components/SquareBtn';
import { container } from '@/container';
import { MODAL_NAMES__EPOS } from '@/epos/vue/modals/MODAL_NAMES__EPOS';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';

export default {
    components: {
        CustomerGoCardlessPaymentTokens,
        SquareBtn,
        Modal,
    },

    mixins: [
        ModalPropsMixin,
    ],

    props: {
        /**
         * @type {CustomerAccount}
         */
        customerAccount: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
        };
    },

    computed: {
        loading() {
            return this.$refs['payment-tokens']?.loading;
        },
    },

    methods: {
        /**
         * @returns {Promise<void>}
         */
        async addNewAccount() {
            try {
                await container.vueModalFactory.open(
                    MODAL_NAMES__EPOS.ADD_GOCARDLESS_BANK_ACCOUNT,
                    {
                        customerAccount: this.customerAccount,
                    },
                );

                // Update the list of payment tokens.
                await this.$refs['payment-tokens'].loadPaymentTokens();
            } catch {
                // Cancelled — do nothing.
            }
        },
    },
};
</script>
